import React from 'react'; 
import WithConsumer from '../context/WithConsumer';
import GravityForm from "react-gravity-form";
import FadeIn from "react-lazyload-fadein";
import { Parallax } from 'react-scroll-parallax';
import Foot from './Foot';

const Lampshades = ({ context }) => {

    const posts = () => context.posts;
    const post = posts()[0];
    
    const lampshadesCtx = () => context.lampshades;
    let lampshades 		= lampshadesCtx();
    
    const ctxPageLoaded = () => context.pageLoaded;
	const pageLoaded = ctxPageLoaded();

    const ctxDoRender = () => context.doRender;
	const doRender = ctxDoRender();
		  
    let pageClass = 'c-page-wrapper state-not-loaded';
	if (pageLoaded == true) {
	    pageClass = 'c-page-wrapper state-loaded';
	}
    	
	function toggleAccordion(event) {
		event.preventDefault();
		let index = parseInt(event.target.getAttribute('data-index'));
		if (lampshades.open.includes(index)) {
			lampshades.open.splice(lampshades.open.indexOf(index), 1);
		} else {
			lampshades.open.push(index);
		}
		context.updateLampshades(lampshades);
	}
	
    function toggleShape(event) {
		event.preventDefault();
		lampshades.shape = event.target.getAttribute('data-label');
		document.getElementById('input_6_1').value = lampshades.shape;
		document.getElementById('input_6_1').dispatchEvent(new Event('blur'));
		if (lampshades.open.includes(1) === false) {
			lampshades.open.push(1);
		}
		context.updateLampshades(lampshades);
	}
	
	function toggleSize(event) {
		event.preventDefault();
		lampshades.size = event.target.getAttribute('data-label');
		document.getElementById('input_6_2').value = lampshades.size;
		document.getElementById('input_6_2').dispatchEvent(new Event('blur'));
		if (lampshades.open.includes(2) === false) {
			lampshades.open.push(2);
		}
		context.updateLampshades(lampshades);
	}
	
    function toggleFittingType(event) {
		event.preventDefault();
		lampshades.fittingtype = event.target.getAttribute('data-label');
		
		lampshades.fittingdimension = null;
		document.getElementById('input_6_4').value = '';
		document.getElementById('input_6_4').dispatchEvent(new Event('blur'));
		lampshades.washersize = null;
		document.getElementById('input_6_5').value = '';
		document.getElementById('input_6_5').dispatchEvent(new Event('blur'));
		lampshades.fabric = null;
		document.getElementById('input_6_6').value = '';
		document.getElementById('input_6_6').dispatchEvent(new Event('blur'));
		lampshades.specialtrim = null;
		document.getElementById('input_6_7').value = '';
		document.getElementById('input_6_7').dispatchEvent(new Event('blur'));
		lampshades.specialtrimlocation = null;
		document.getElementById('input_6_8').value = '';
		document.getElementById('input_6_8').dispatchEvent(new Event('blur'));
		if (lampshades.open.includes(3) === false) {
			lampshades.open.push(3);
		}
		if (lampshades.open.includes(8) === false) {
			lampshades.open.push(8);
		}
		document.getElementById('input_6_3').value = lampshades.fittingtype;
		document.getElementById('input_6_3').dispatchEvent(new Event('blur'));
		context.updateLampshades(lampshades);
	}
	
	function toggleFittingDimension(event) {
		event.preventDefault();
		lampshades.fittingdimension = event.target.getAttribute('data-label');
		document.getElementById('input_6_4').value = lampshades.fittingdimension;
		document.getElementById('input_6_4').dispatchEvent(new Event('blur'));
		if (lampshades.open.includes(4) === false) {
			lampshades.open.push(4);
		}
		context.updateLampshades(lampshades);
	}
	
	function toggleWasherSize(event) {
		event.preventDefault();
		lampshades.washersize = event.target.getAttribute('data-label');
		document.getElementById('input_6_5').value = lampshades.washersize;
		document.getElementById('input_6_5').dispatchEvent(new Event('blur'));
		if (lampshades.open.includes(5) === false) {
			lampshades.open.push(5);
		}
		context.updateLampshades(lampshades);
	}
	
	function toggleFabric(event) {
		event.preventDefault();
		if (lampshades.fabric === event.target.getAttribute('data-label')) {
			lampshades.fabric = null;
			document.getElementById('input_6_6').value = '';
		} else {
			lampshades.fabric = event.target.getAttribute('data-label');
			document.getElementById('input_6_6').value = lampshades.fabric;
		}
		
		document.getElementById('input_6_6').dispatchEvent(new Event('blur'));
		if (lampshades.open.includes(6) === false) {
			lampshades.open.push(6);
		} 
		context.updateLampshades(lampshades);
	}
	
	function toggleSpecialTrim(event) {
		event.preventDefault();
		lampshades.specialtrim = event.target.getAttribute('data-label');
		document.getElementById('input_6_7').value = lampshades.specialtrim;
		document.getElementById('input_6_7').dispatchEvent(new Event('blur'));
		if (lampshades.open.includes(7) === false) {
			lampshades.open.push(7);
		}
		context.updateLampshades(lampshades);
	}
	
	function toggleSpecialTrimLocation(event) {
		event.preventDefault();
		lampshades.specialtrimlocation = event.target.getAttribute('data-label');
		document.getElementById('input_6_8').value = lampshades.specialtrimlocation;
		document.getElementById('input_6_8').dispatchEvent(new Event('blur'));
		if (lampshades.open.includes(8) === false) {
			lampshades.open.push(8);
		}
		context.updateLampshades(lampshades);
	}
	
	function resetForm(event) {
		event.preventDefault();
		lampshades.shape = null;
		lampshades.size = null;
		lampshades.fittingtype = null;
		lampshades.fittingdimension = null;
		lampshades.washersize = null;
		lampshades.fabric = null;
		lampshades.specialtrim = null;
		lampshades.specialtrimlocation = null;
		document.getElementById('input_6_1').value = null;
		document.getElementById('input_6_2').value = null;
		document.getElementById('input_6_3').value = null;
		document.getElementById('input_6_4').value = null;
		document.getElementById('input_6_5').value = null;
		document.getElementById('input_6_6').value = null;
		document.getElementById('input_6_7').value = null;
		document.getElementById('input_6_8').value = null;
		document.getElementById('input_6_9').value = null;
		document.getElementById('input_6_11').value = null;
		document.getElementById('input_6_12').value = null;
		document.getElementById('input_6_13').value = null;
		document.getElementById('input_6_14').value = null;
		document.getElementById('input_6_1').dispatchEvent(new Event('blur'));
		document.getElementById('input_6_2').dispatchEvent(new Event('blur'));
		document.getElementById('input_6_3').dispatchEvent(new Event('blur'));
		document.getElementById('input_6_4').dispatchEvent(new Event('blur'));
		document.getElementById('input_6_5').dispatchEvent(new Event('blur'));
		document.getElementById('input_6_6').dispatchEvent(new Event('blur'));
		document.getElementById('input_6_7').dispatchEvent(new Event('blur'));
		document.getElementById('input_6_8').dispatchEvent(new Event('blur'));
		document.getElementById('input_6_9').dispatchEvent(new Event('blur'));
		document.getElementById('input_6_11').dispatchEvent(new Event('blur'));
		document.getElementById('input_6_12').dispatchEvent(new Event('blur'));
		document.getElementById('input_6_13').dispatchEvent(new Event('blur'));
		document.getElementById('input_6_14').dispatchEvent(new Event('blur'));
		context.updateLampshades(lampshades);
		
	}
	
	function submitForm(event) {
		event.preventDefault();
		if (!lampshades.open.includes(8)) {
			lampshades.open.push(8);
		}
		if (lampshades.shape == null || lampshades.size == null || lampshades.fittingtype == null) {
			lampshades.valid = false;
			
			context.updateLampshades(lampshades);
		} else {
			document.getElementById('gravity_form_6').getElementsByTagName('button')[0].click();
			context.updateLampshades(lampshades);
		}
		
		
	}
	
	if (typeof post !== 'undefined') {
		
		if (typeof post.shape !== 'undefined') {
	    	
	    	return (
		    	<div className={pageClass}>
			    	<div className="l-content c-lampshades">
			    		<div className="l-grid">
			    			<div className="l-grid__col l-grid__col--m-6-12">
			    				{ post.heading &&
			    					<h1 className="c-heading">{ post.heading }</h1>
			    				}
			    				{ post.subheading &&
			    					<h2 className="c-paragraph c-paragraph--light c-paragraph--space">{ post.subheading }</h2>
			    				}
			    			</div>
			    			<div className="l-grid__col l-grid__col--m-6-12">
			    				{ post.text &&
				    				<div className="scope-text" dangerouslySetInnerHTML={ {__html: post.text } }></div>
				    			}
			    			</div>
			    			<div className="l-grid__col c-lampshades__form">
			    				
			    				
								<div className={`c-lampshades__accordion ${lampshades.open.includes(0) ? "state-open" : ""}`}>
			    					<a href="#" className="c-lampshades__accordion__header" data-index="0" onClick={toggleAccordion}>Select a shape<div className="c-accordions__item__header__icon"></div></a>
			    					<div className="c-lampshades__accordion__body">
			    						<div className="c-lampshades__accordion__body__inner">
						    				<div className={"c-lampshades__thumbs c-lampshades__thumbs--" + post.shape.length}>
										    	{post.shape.map((shape,i) =>
											    	{
											    		return (
												    		<div className="c-lampshades__thumbs__thumb-wrap" key={i}>
												    			<div className={`c-lampshades__thumbs__thumb ${shape.label == lampshades.shape ? "state-selected" : ""}`}>
												    				<div className="c-lampshades__thumbs__thumb__image">
												    					<FadeIn duration={250}>
																			{onload => (
																				<img
																					alt={shape.label} 
																					src={shape.src} 
																					srcSet={shape.srcset} 
																					onLoad={onload}
																				/>
																			)}
																		</FadeIn>
												    				</div>
												    				<p className="c-lampshades__thumbs__thumb__label">{ shape.label }</p>
												    			</div>
												    			<a href="#" className="c-lampshades__thumbs__thumb__link" data-label={shape.label} onClick={toggleShape}></a>
												    		</div>
											    		)
													}
										    	)}
										    </div>
										</div>
									</div>
							    </div>
							    
							    
							    <div className={`c-lampshades__accordion ${lampshades.open.includes(1) ? "state-open" : ""}`}>
			    					<a href="#" className="c-lampshades__accordion__header" data-index="1" onClick={toggleAccordion}>Select a size<div className="c-accordions__item__header__icon"></div></a>
			    					<div className="c-lampshades__accordion__body">
			    						<div className="c-lampshades__accordion__body__inner">
						    				<div className={"c-lampshades__options c-lampshades__options--" + post.size.length}>
										    	{post.size.map((size,i) =>
											    	{
											    		return (
												    		<div className="c-lampshades__options__option" key={i}>
												    			<a href="#" className={`c-lampshades__options__option__button ${size.label == lampshades.size ? "state-selected" : ""}`} data-label={size.label} onClick={toggleSize}>{size.label + '"'}</a>
												    			<p className="c-lampshades__options__option__text" dangerouslySetInnerHTML={ {__html: size.text } }></p>
												    		</div>
											    		)
													}
										    	)}
										    </div>
										</div>
									</div>
							    </div>
							    
							    
							    <div className={`c-lampshades__accordion ${lampshades.open.includes(2) ? "state-open" : ""}`}>
			    					<a href="#" className="c-lampshades__accordion__header" data-index="2" onClick={toggleAccordion}>Lampshade fitting - type<div className="c-accordions__item__header__icon"></div></a>
			    					<div className="c-lampshades__accordion__body">
			    						<div className="c-lampshades__accordion__body__inner">
						    				<div className={"c-lampshades__thumbs c-lampshades__thumbs--" + post.fittingtype.length}>
										    	{post.fittingtype.map((fittingtype,i) =>
											    	{
											    		return (
												    		<div className="c-lampshades__thumbs__thumb-wrap" key={i}>
												    			<div className={`c-lampshades__thumbs__thumb ${fittingtype.label == lampshades.fittingtype ? "state-selected" : ""}`}>
												    				<div className="c-lampshades__thumbs__thumb__image">
												    					<FadeIn duration={250}>
																			{onload => (
																				<img
																					alt={fittingtype.label} 
																					src={fittingtype.src} 
																					srcSet={fittingtype.srcset} 
																					onLoad={onload}
																				/>
																			)}
																		</FadeIn>
												    				</div>
												    				<p className="c-lampshades__thumbs__thumb__label">{ fittingtype.label }</p>
												    			</div>
												    			<a href="#" className="c-lampshades__thumbs__thumb__link" data-label={fittingtype.label} onClick={toggleFittingType}></a>
												    		</div>
											    		)
													}
										    	)}
										    </div>
										</div>
									</div>
							    </div>
							    
							    
							    <div className={`c-lampshades__accordion ${lampshades.open.includes(3) && lampshades.fittingtype !== 'Custom' ? "state-open" : ""} ${lampshades.fittingtype === 'Custom' ? "state-inactive" : ""}`}>
			    					<a href="#" className="c-lampshades__accordion__header" data-index="3" onClick={toggleAccordion}>Lampshade fitting – Dimensions<div className="c-accordions__item__header__icon"></div></a>
			    					<div className="c-lampshades__accordion__body">
			    						<div className="c-lampshades__accordion__body__inner">
						    				<div className={"c-lampshades__options c-lampshades__options--" + post.fittingdimension.length}>
										    	{post.fittingdimension.map((fittingdimension,i) =>
											    	{
												    	if (fittingdimension.label.includes(lampshades.fittingtype) === true && lampshades.fittingtype !== null && lampshades.fittingtype !== 'Custom') {
											    			return (
													    		<div className="c-lampshades__options__option" key={i}>
													    			<h4 className="c-lampshades__options__option__heading" dangerouslySetInnerHTML={ {__html: fittingdimension.label } }></h4>
													    			{fittingdimension.option.map((option,j) =>
																		{
																			return (
																				<a href="#" className={`c-lampshades__options__option__button ${option == lampshades.fittingdimension ? "state-selected" : ""}`} data-label={option} onClick={toggleFittingDimension} key={j}>{option}</a>
																			)		
																		}
																	)}
													    		</div>
												    		)
											    		} else {
												    		return (
													    		<div className="c-lampshades__options__option" key={i}>
													    			<h4 className="c-lampshades__options__option__heading state-inactive" dangerouslySetInnerHTML={ {__html: fittingdimension.label } }></h4>
													    			{fittingdimension.option.map((option,j) =>
																		{
																			return (
																				<a href="#" className={`c-lampshades__options__option__button state-inactive`} data-label={option} onClick={toggleFittingDimension} key={j}>{option}</a>
																			)		
																		}
																	)}
													    		</div>
												    		)
											    		}
													}
										    	)}
										    </div>
										</div>
									</div>
							    </div>
							    
							    
							    
							    <div className={`c-lampshades__accordion ${lampshades.open.includes(4) && lampshades.fittingtype !== 'Custom' ? "state-open" : ""}${lampshades.fittingtype === 'Custom' ? "state-inactive" : ""}`}>
			    					<a href="#" className="c-lampshades__accordion__header" data-index="4" onClick={toggleAccordion}>Lampshade washer size<div className="c-accordions__item__header__icon"></div></a>
			    					<div className="c-lampshades__accordion__body">
			    						<div className="c-lampshades__accordion__body__inner">
						    				<div className={"c-lampshades__options c-lampshades__options--" + post.washersize.length}>
										    	{post.washersize.map((washersize,i) =>
											    	{
												    	if (washersize.label.includes(lampshades.fittingtype) === true && lampshades.fittingtype !== null && lampshades.fittingtype !== 'Custom') {
												    		return (
													    		<div className="c-lampshades__options__option" key={i}>
													    			<h4 className="c-lampshades__options__option__heading" dangerouslySetInnerHTML={ {__html: washersize.label } }></h4>
													    			{washersize.option.map((option,j) =>
																		{
																			return (
																				<a href="#" className={`c-lampshades__options__option__button ${option == lampshades.washersize ? "state-selected" : ""}`} data-label={option} onClick={toggleWasherSize} key={j}>{option}</a>
																			)		
																		}
																	)}
													    		</div>
												    		)
												    	} else {
													    	return (
													    		<div className="c-lampshades__options__option" key={i}>
													    			<h4 className="c-lampshades__options__option__heading" dangerouslySetInnerHTML={ {__html: washersize.label } }></h4>
													    			{washersize.option.map((option,j) =>
																		{
																			return (
																				<a href="#" className={`c-lampshades__options__option__button state-inactive`} data-label={option} onClick={toggleWasherSize} key={j}>{option}</a>
																			)		
																		}
																	)}
													    		</div>
												    		)
												    	}
													}
										    	)}
										    </div>
										</div>
									</div>
							    </div>
							    
							    
							    <div className={`c-lampshades__accordion ${lampshades.open.includes(5) && lampshades.fittingtype !== 'Custom' ? "state-open" : ""}${lampshades.fittingtype === 'Custom' ? "state-inactive" : ""}`}>
			    					<a href="#" className="c-lampshades__accordion__header" data-index="5" onClick={toggleAccordion}>Fabric<div className="c-accordions__item__header__icon"></div></a>
			    					<div className="c-lampshades__accordion__body c-lampshades__accordion__body--fabric">
			    						<div className="c-lampshades__accordion__body__inner">
						    				<div className="c-lampshades__fabrics">
										    	{post.fabric.map((fabric,i) =>
											    	{
											    		return (
												    		<div key={i} className={`c-fabrics__swatch state-toggle ${fabric.name == lampshades.fabric ? "state-selected state-active" : ""} ${lampshades.fittingtype === 'Custom' ? "state-inactive" : ""}`}>
																{fabric.swatch_src && 
																	<div className="c-fabrics__swatch__inner">
																		<FadeIn duration={250}>
																			{onload => (
																				<img
																					alt={fabric.name} 
																					src={fabric.swatch_src} 
																					srcset={fabric.swatch_srcset}
																					onLoad={onload}
																				/>
																			)}
																		</FadeIn>
																	</div>
																}
																{fabric.swatch_hex &&
																	<div className="c-fabrics__swatch__inner" style={{ backgroundColor: fabric.swatch_hex }}></div>
																}
																<p className="c-fabrics__swatch__text">{ fabric.name }</p>
																<a href="#" key={i} className="c-fabrics__link" data-label={fabric.name} onClick={toggleFabric}></a>
															</div>	
											    		)
													}
										    	)}
										    </div>
										</div>
									</div>
							    </div>
							    
							    
							    <div className={`c-lampshades__accordion ${lampshades.open.includes(6) && lampshades.fittingtype !== 'Custom' ? "state-open" : ""} ${lampshades.fittingtype === 'Custom' ? "state-inactive" : ""}`}>
			    					<a href="#" className="c-lampshades__accordion__header" data-index="6" onClick={toggleAccordion}>Special Trim<div className="c-accordions__item__header__icon"></div></a>
			    					<div className="c-lampshades__accordion__body">
			    						<div className="c-lampshades__accordion__body__inner">
						    				<div className={"c-lampshades__thumbs c-lampshades__thumbs--" + post.specialtrim.length}>
										    	{post.specialtrim.map((specialtrim,i) =>
											    	{
											    		return (
												    		<div className="c-lampshades__thumbs__thumb-wrap" key={i}>
												    			<div className={`c-lampshades__thumbs__thumb ${specialtrim.label == lampshades.specialtrim ? "state-selected" : ""}`}>
												    				<div className="c-lampshades__thumbs__thumb__image">
												    					<FadeIn duration={250}>
																			{onload => (
																				<img
																					alt={specialtrim.label} 
																					src={specialtrim.src} 
																					srcSet={specialtrim.srcset} 
																					onLoad={onload}
																				/>
																			)}
																		</FadeIn>
												    				</div>
												    				<p className="c-lampshades__thumbs__thumb__label">{ specialtrim.label }</p>
												    			</div>
												    			<a href="#" className="c-lampshades__thumbs__thumb__link" data-label={specialtrim.label} onClick={toggleSpecialTrim}></a>
												    		</div>
											    		)
													}
										    	)}
										    </div>
										</div>
									</div>
							    </div>
							    
							    <div className={`c-lampshades__accordion ${lampshades.open.includes(7) && lampshades.fittingtype !== 'Custom' ? "state-open" : ""} ${lampshades.fittingtype === 'Custom' ? "state-inactive" : ""}`}>
			    					<a href="#" className="c-lampshades__accordion__header" data-index="7" onClick={toggleAccordion}>Special Trim (locations)<div className="c-accordions__item__header__icon"></div></a>
			    					<div className="c-lampshades__accordion__body">
			    						<div className="c-lampshades__accordion__body__inner">
			    							<p className="c-lampshades__accordion__body__header">Select where the Special trim is to appear</p>
						    				<div className={"c-lampshades__options c-lampshades__options--" + post.specialtrimlocation.length}>
						    					
										    	{post.specialtrimlocation.map((specialtrimlocation,i) =>
											    	{
											    		return (
												    		<div className="c-lampshades__options__option" key={i}>
												    			<a href="#" className={`c-lampshades__options__option__button ${specialtrimlocation.label == lampshades.specialtrimlocation ? "state-selected" : ""}`} data-label={specialtrimlocation.label} onClick={toggleSpecialTrimLocation}>{specialtrimlocation.label}</a>
												    		</div>
											    		)
													}
										    	)}
										    </div>
										</div>
									</div>
							    </div>
							    
							    <div className={`c-lampshades__accordion ${lampshades.open.includes(8) ? "state-open" : ""}`}>
			    					<a href="#" className="c-lampshades__accordion__header" data-index="8" onClick={toggleAccordion}>Enter your details<div className="c-accordions__item__header__icon"></div></a>
			    					<div className="c-lampshades__accordion__body">
			    						<div className="c-lampshades__accordion__body__inner">
											
											{lampshades.valid === false &&
												<div className="c-lampshades__footer__message">
													<p>Please fill out all the options above and resubmit this form</p>
												</div>
											}
									
											<div className="scope-form scope-form--lampshades c-lampshade__form">
											
												<GravityForm
														backendUrl={document.location.origin + '/wp-json/bloomingdales/v1/form'}
														formID={post.form}
														populatedFields={{
															shape: lampshades.shape,
															size: lampshades.size,
															fittingtype: lampshades.fittingtype,
															fittingdimension: lampshades.fittingdimension,
															washersize: lampshades.washersize,
															fabric: lampshades.fabric,
															specialtrim: lampshades.specialtrim,
															specialtrimlocation: lampshades.specialtrimlocation
														}}
													/>
										    </div>
										</div>
									</div>
								</div>
								
								<div className="c-lampshades__footer">
								
									
									
									<a href="#" className="c-lampshades__reset" onClick={resetForm}>Reset</a>
									
									<a href="#" className="c-lampshades__submit" onClick={submitForm}>Submit</a>
									
								</div>
							    
							</div>
							
							
						</div>
					</div>
					<Foot></Foot>
				</div>
	    	)
	    } else {
		    return null;
	    }
		    		
	} else {
		return null;
	}
};
export default WithConsumer(Lampshades);